import { useEffect, useState } from 'react';

const KEYBOARD_OPEN_ATTR = 'data-keyboard-open';

/**
 * Subscribes to the document's data-keyboard-open attribute (set by
 * useVisualViewportHeight when the mobile keyboard is detected).
 * Returns true when the attribute is "true", so components can adjust
 * layout (e.g. hide landscape arrow, force portrait layout).
 */
export const useKeyboardOpen = (): boolean => {
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(() => {
        if (typeof document === 'undefined') return false;
        return (
            document.documentElement.getAttribute(KEYBOARD_OPEN_ATTR) === 'true'
        );
    });

    useEffect(() => {
        const el = document.documentElement;
        const check = () =>
            setIsKeyboardOpen(el.getAttribute(KEYBOARD_OPEN_ATTR) === 'true');
        const observer = new MutationObserver(check);
        observer.observe(el, {
            attributes: true,
            attributeFilter: [KEYBOARD_OPEN_ATTR],
        });
        check();
        return () => observer.disconnect();
    }, []);

    return isKeyboardOpen;
};
